module.exports = __webpack_public_path__ + "static/media/CEPINA_MENU-normal.ce7fee19.png";